export default __webpack_public_path__ + "img/digitaltwin.1cec232e.png";